import './globals';
import './methods';

import React from 'react';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import { createRoot } from 'react-dom/client';
const container = document.getElementById('app');
const root = createRoot(container);
root.render(<App tab="home" />);

serviceWorkerRegistration.register();
